var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRePaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5Z",
    fill: "#0066FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5420_3859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.63314 11.6334L10.6404 9.62619L10.1252 9.11106L8.62426 10.612L7.87821 9.866L7.37196 10.3722L8.63314 11.6334ZM6.87459 13.0545C6.67919 13.0545 6.51192 12.9849 6.37278 12.8458C6.23363 12.7066 6.16406 12.5394 6.16406 12.344V6.65975C6.16406 6.46435 6.23363 6.29708 6.37278 6.15794C6.51192 6.01879 6.67919 5.94922 6.87459 5.94922H9.71669L11.8483 8.0808V12.344C11.8483 12.5394 11.7787 12.7066 11.6396 12.8458C11.5004 12.9849 11.3331 13.0545 11.1377 13.0545H6.87459ZM9.36143 8.43606H11.1377L9.36143 6.65975V8.43606Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5420_3859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.52632,
    height: 8.52632,
    fill: "white",
    transform: "translate(4.74219 5.23828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRePaid);
export default __webpack_public_path__ + "static/media/rePaid.c87d8c0162e1f08ad9c3a31bb0e7a76f.svg";
export { ForwardRef as ReactComponent };